import v1HeaderToggle from './v1HeaderToggle';
import v1HeaderFixed from './v1HeaderFixed';
import v1HeaderCurrent from './v1HeaderCurrent';
import v1HeaderSvg from './v1HeaderSvg';
import v1HeaderInfo from './v1HeaderInfo';

export default function v1Header() {
  v1HeaderInfo();

  window.addEventListener('load', () => {
    v1HeaderFixed();
    v1HeaderToggle();
    v1HeaderSvg();
    v1HeaderCurrent();
  });
}
